import {
  configApiRef,
  fetchApiRef,
  identityApiRef,
} from '@backstage/core-plugin-api';

import {
  editRouteRef,
  newRouteRef,
  removeRouteRef,
  rootRouteRef,
} from './routes';
import { GithubRunnersClient, githubRunnersApiRef } from './api';
import {
  ApiBlueprint,
  createFrontendPlugin,
  FrontendPlugin,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';
import {
  compatWrapper,
  convertLegacyRouteRef,
  convertLegacyRouteRefs,
} from '@backstage/core-compat-api';
import { githubRunnerCreatePermission } from '@internal/plugin-github-runners-common';
import { RequirePermission } from '@backstage/plugin-permission-react';
import { RiRunLine } from '@remixicon/react';

const githubRunnersApi = ApiBlueprint.make({
  name: 'confluent',
  params: defineParams =>
    defineParams({
      api: githubRunnersApiRef,
      deps: {
        identityApi: identityApiRef,
        fetchApi: fetchApiRef,
        configApi: configApiRef,
      },
      factory: ({ identityApi, configApi, fetchApi }) =>
        new GithubRunnersClient({ identityApi, configApi, fetchApi }),
    }),
});

const githubRunnersPage = PageBlueprint.make({
  name: 'github-runners',
  params: {
    icon: <RiRunLine />,
    title: 'Github Runners',
    path: '/github-runners',
    routeRef: convertLegacyRouteRef(rootRouteRef),
    loader: () =>
      import('./components/GithubRunnerComponent').then(m =>
        compatWrapper(
          <RequirePermission permission={githubRunnerCreatePermission}>
            <m.GithubRunnerComponent />
          </RequirePermission>,
        ),
      ),
  },
});

export const githubRunnersPlugin: FrontendPlugin = createFrontendPlugin({
  pluginId: 'github-runners',
  info: {
    packageJson: () => import('../package.json'),
  },
  extensions: [githubRunnersApi, githubRunnersPage],
  routes: convertLegacyRouteRefs({
    root: rootRouteRef,
    edit: editRouteRef,
    remove: removeRouteRef,
    new: newRouteRef,
  }),
});
